module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/clients/edit-client-modal/edit-client-modal.component.scss
// module id = ./src/app/clients/edit-client-modal/edit-client-modal.component.scss
// module chunks = main